import axios from 'axios'
import ElementUI from 'element-ui'

axios.defaults.withCredentials = true // 允许携带cookie

// 登录态已失效（服务端已删除会话：修改密码、被禁用、被删除等）
// 清除本地登录信息并跳转登录页，多个并发请求只处理一次
// silent 为 true 时不再弹提示（业务代码已自行提示，如自己修改密码成功）
let needLoginHandling = false
function handleNeedLogin(msg, silent) {
  // 已经处于登录页时不再处理：App.vue created 会在每次加载时调用 /admin/roleVersion，
  // 未登录时该接口返回 needLogin:true，若此处仍执行 localStorage.clear + 跳转 /login，
  // 会造成“登录页重载 -> 又调 roleVersion -> 又跳转”的死循环，表现为反复刷新、一直提示重新登录
  if (window.location.pathname === '/login') return
  if (needLoginHandling) return
  needLoginHandling = true
  if (!silent) {
    ElementUI.Message.error(msg || '登录状态已失效，请重新登录')
  }
  // 同时清掉 sessionId 与 vuex 持久化（loginAccount、navList）
  localStorage.clear()
  setTimeout(() => {
    window.location.href = '/login'
  }, 1000)
}

// 在request拦截器中显示进度条Nprogress.start()
axios.interceptors.request.use((config) => {
  // 请求开始时显示进度条
  // NProgress.start();
  return config
})

// 返回状态判断
axios.interceptors.response.use(
  (res) => {
    // res中完成进度条Nprogress.done()
    // NProgress.done();
    if (res.status === 200 && res.data.state === 'fail') {
      // 需要重新登录
      if (res.data.needLogin) {
        handleNeedLogin(res.data.msg)
      } else if (res.data.msg) {
        setTimeout(() => {
          ElementUI.Message.error(res.data.msg)
        })
      }
    }
    // 自己修改密码成功，服务端已让旧会话失效，需要重新登录
    if (res.status === 200 && res.data.state === 'ok' && res.data.needLogin) {
      handleNeedLogin(null, true)
    }
    if (res.status === 200 && res.data.state === 'fail' && res.data.closeSystem) {
      window.location = 'http://www.baidu.com'
    } else if (res.status === 200 && res.data.state === 'fail' && res.data.showCommonStr) {
      ElementUI.Message.error(res.data.msg)
    } else {
      return res
    }
    //closeSystem
  },
  (err) => {
    // 对响应错误做点什么
    if (err.response) {
      // 请求已发出，服务器返回状态码超出2xx范围
      const { status, config } = err.response
      if (status === 500) {
        // 可以在这里处理500错误，比如显示提示、跳转页面等
        ElementUI.Message.error(`服务器报500错误(${config.url})`)
      }
    }

    return Promise.reject(err)
  }
)

export default axios
